import { AppFeatureService } from "@sleek-sdk/sleek-cms";
import includes from "lodash/includes";
import pMemoize from "p-memoize";

import GetPlatformConfig from "@/proxies/back-end/config/get-platform-config";
import getAppCustomEnv from "@/utilities/get-app-custom-env";

import OverrideAppFeatures from "/src/app-features";
import { Constants } from "customer-sdk/constants";

const { SLEEK_DOMAINS } = Constants.SLEEK_DOMAINS;
const getSettings = async () => {
  const appCustomEnv = await getAppCustomEnv();
  const debugMode = process.env.NODE_ENV === "development";

  if (process.env.NODE_ENV === "development") {
    return {
      remote_base_url: process.env.VUE_APP_CMS_CONTENT_REMOTE_URL || appCustomEnv.VUE_APP_CMS_CONTENT_REMOTE_URL,
      environment: process.env.VUE_APP_CMS_CONTENT_ENVIRONMENT || appCustomEnv.VUE_APP_CMS_CONTENT_ENVIRONMENT,
      country_code: process.env.VUE_APP_CMS_CONTENT_COUNTRY_CODE || appCustomEnv.VUE_APP_CMS_CONTENT_COUNTRY_CODE,
      debug: debugMode
    };
  }

  return {
    remote_base_url: appCustomEnv.VUE_APP_CMS_CONTENT_REMOTE_URL,
    environment: appCustomEnv.VUE_APP_CMS_CONTENT_ENVIRONMENT,
    country_code: appCustomEnv.VUE_APP_CMS_CONTENT_COUNTRY_CODE,
    debug: debugMode
  };
};

export const getPlatformConfig = async (hostName) => {
  const settings = await getSettings();
  AppFeatureService.override(OverrideAppFeatures);
  const appFeatureService = new AppFeatureService({
    settings: settings,
    options: {
      returnNullIfNotFound: false
    }
  });
  const isHostSleek = includes(SLEEK_DOMAINS, hostName);
  const platform = isHostSleek ? "customer" : "partner";
  const proxy = new GetPlatformConfig();
  if (isHostSleek) {
    const [backendConfig, cmsAppFeatures, cmsGeneralFeatureList] = await Promise.all([
      proxy.getPlatformConfigFromServer({ platform: platform }),
      appFeatureService.getCustomerFeatureList(),
      appFeatureService.getGeneralFeatureList(),
    ]);
    backendConfig.cmsAppFeatures = cmsAppFeatures;
    backendConfig.cmsGeneralFeatureList = cmsGeneralFeatureList;
    return backendConfig;
  } else {
    // Partner clients have unique settings in db - app features will be merged from the backend
    return await proxy.getPlatformConfigFromServer({ platform: platform });
  }
};

export default pMemoize(getPlatformConfig);